import LocationModal from './LocationModal';

export default {
  LocationModal,
};
